export class BaseAPISvc {
	constructor($http, PUBLIC_KEY, APIDbSvc, API, ENV) {
		'ngInject';
		this.API = API;
		this.ENV = ENV;
		this.PUBLIC_KEY = PUBLIC_KEY;
		this.http = $http;
		this.dbSvc = APIDbSvc;
	}

	// Native URLSearchParams only does the "repeat" format
	searchParams(obj) {
		if (!obj) return false;
		if (typeof obj === 'string') return false;
		if (Object.keys(obj).length === 0) return false;
		const qs = new URLSearchParams(obj);
		return qs.toString();
	}
}
